import React from 'react'
import { SwiperSlide, Swiper } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import style from '../styles/lessons.module.scss'
import { GxIcon } from '@garpix/garpix-web-components-react'
import { arrowRightIcon } from '@/images'
import SliderContainer from '@/components/Container/SliderContainer'
import { PlaceholderLoading } from '@/components/PlaceholderLoading'
import { useConfig } from '@/hooks'
import { ILesson } from '@/interfaces/Lessons'

SwiperCore.use([Navigation])

interface IProps {
  lessons?: ILesson[] | undefined
  prefix?: string
  backLink: string
  backTitle: string
}

const LessonsSlider = ({
  lessons,
  prefix = '',
  backLink,
  backTitle
}: IProps): React.ReactElement => {
  const config = useConfig()
  return (
    <SliderContainer>
      <div className={style.slider_buttons}>
        <button className={`slider_button slider_button_prev js_lessons_prev_${prefix}`}>
          <GxIcon src={arrowRightIcon} className={style.slider__icon} />
        </button>
        <button className={`slider_button slider_button_next js_lessons_next_${prefix}`}>
          <GxIcon src={arrowRightIcon} className={style.slider__icon} />
        </button>
      </div>
      <Swiper
        slidesPerView='auto'
        spaceBetween={20}
        resizeObserver
        navigation={{
          prevEl: `.js_lessons_prev_${prefix}`,
          nextEl: `.js_lessons_next_${prefix}`
        }}
        freeMode
        grabCursor
      >
        {lessons === undefined
          ? (
            <>
              <SwiperSlide className={style.slider__slide}>
                <PlaceholderLoading shape='rect' width='100%' height='100%' />
              </SwiperSlide>
              <SwiperSlide className={style.slider__slide}>
                <PlaceholderLoading shape='rect' width='100%' height='100%' />
              </SwiperSlide>
              <SwiperSlide className={style.slider__slide}>
                <PlaceholderLoading shape='rect' width='100%' height='100%' />
              </SwiperSlide>
            </>
            )
          : (
              lessons.map((slide, i) => {
                return (
                  <SwiperSlide key={slide.id} className={style.slider__slide}>
                    <a
                      href={`${config.lesson}?element_id=${slide.id}&link=${backLink}&title=${backTitle}`}
                      title={slide.name}
                      className={style.slider__link}
                    >
                      <span className={style.slider__lesson}>
                        {`Урок ${i + 1}:`}
                      </span>
                      <span className={style.slider__text}>{slide.name}</span>
                    </a>
                    <img
                      src={slide.preview_picture?.[0] ?? ''}
                      width='421px'
                      height='311'
                      alt={slide.name}
                      className={style.slider__image}
                    />
                  </SwiperSlide>
                )
              })
            )}
      </Swiper>
    </SliderContainer>
  )
}

export default LessonsSlider
